import type { FaireOrderEntity } from "../../entity_types/order";

export const R47R7FTVWG: FaireOrderEntity = {
  token: "R47R7FTVWG",
  type: "order",
  orderNumber: "#R47R7FTVWG",
  status: "fulfilled",
  totalDollars: 143.05,
  customerName: "Wildflower Sundries",
  firstOrder: false,
  placedAt: "Nov 27, 2025",
  shipBy: "Sep 3, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Nov 27, 2025",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
